import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import { txUrl, shortHash } from 'utils/marketplace/explorer'

const Panel = styled(Flex)`
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.green};
  background: ${({ theme }) => `${theme.colors.green}11`};
`

const Link = styled.a`
  color: ${({ theme }) => theme.colors.cyan};
  font-size: 13px;
  text-decoration: underline;
  word-break: break-all;
  &:hover {
    opacity: 0.85;
  }
`

interface TxConfirmationProps {
  hash: string
  title: string
  chainId?: number
}

/**
 * Shown after a transaction confirms. The hash is the user's own record of
 * what happened — a toast that disappears is not one.
 */
const TxConfirmation: React.FC<TxConfirmationProps> = ({
  hash,
  title,
  chainId
}) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  return (
    <Panel>
      <Text variant={TextVariant.BODY_SMALL_BOLD}>{title}</Text>
      <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.gray6}>
        {t('marketplace.txConfirmed')}
      </Text>
      <Link href={txUrl(hash, chainId)} target="_blank" rel="noreferrer">
        {shortHash(hash)} — {t('marketplace.viewTx')}
      </Link>
    </Panel>
  )
}

export default TxConfirmation
